import React from "react";

import PrimaryButton from "../../../../../../../../components/buttons/PrimaryButton";

interface IProps {
  isLoading: boolean;
}

const FormButtons = ({ isLoading }: IProps) => {
  return (
    <div className="mb-4 mt-4 flex flex-row">
      <PrimaryButton
        loading={isLoading}
        title={"Actualizar"}
        className={
          "mt-5 rounded-3xl bg-buttonBlack px-5 py-1 text-sm font-normal text-whiteSoft"
        }
        type="submit"
      />
    </div>
  );
};

export default FormButtons;
